import { useScrollEvent } from "@/hooks/useScrollEvent"
import { usePopoverContext } from "@chakra-ui/react"

export const PopoverScrollCloseTrigger = () => {
  const popover = usePopoverContext()
  useScrollEvent({
    enabled: popover.isOpen,
    listener: () => {
      if (popover.isOpen) {
        popover.onClose()
      }
    }
  });
  return null

}